var _defs, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortraitM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ShapeLayer",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "93.5 100.5 90.6 104.6 82.3 110.7 69.9 117.8 66 118.2 54 118.2 50.8 116.6 37.8 106.2 33.7 101.9 32.1 96.2 31.1 87.3 27.8 86.9 25.6 80.8 21.3 66.9 20.7 63.5 22.3 61.3 24.4 61.3 24.8 55.4 22.1 53.5 23.1 50.9 22.7 47.6 20.7 44.4 22.5 41.3 22.9 38.3 22.9 32.2 23.9 27.3 27 22.4 30 20 33.3 19.4 33.7 15.5 34.9 13.5 40.4 9.4 43.7 6.2 45.3 3.3 46.5 3.9 49.8 4.7 55.3 2.3 56.3 -.2 58.5 3.3 61.2 4.1 69.1 2.7 75.6 -.2 75.6 2.5 77.8 2.9 81.3 1.5 80.9 3.1 84.9 3.5 83.9 5.5 89.8 5.9 90.6 8.2 88.4 10.2 89.6 14.5 92.5 17.5 96.7 20.2 99.2 21 98.4 23.2 99.2 25.1 102.6 26.7 107.3 28.1 105.3 30.8 103.6 32.6 103.2 36.7 102.6 40.5 104.1 43.2 104.9 46.2 104.3 49.5 103.9 52.7 103 55 102.8 60.4 104.3 62.1 105.7 62.1 106.5 66.5 105.5 70.6 101.8 81.4 99.8 85.5 97.3 87.3 95.1 87.7 93.5 100.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "36.6 106.1 49.8 116.7 54.4 118.3 70.1 118.1 75.6 115.5 83.3 111 89.4 106.1 89.4 109.6 90.6 112.8 93.3 116.9 95.3 118.3 93.1 120.6 87.6 123.2 79.2 125.4 66 126.1 44.7 125 37 123.4 31.5 121 30.2 120 33.7 117.7 35.9 114.3 37 109.8 36.6 106.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortraitM);
export default __webpack_public_path__ + "static/media/portrait_m.28894ba7197470f82f4d31c9142c85e1.svg";
export { ForwardRef as ReactComponent };